<template>
  <section class="relative h-fit">
    <img src="@images/landing-page/waves.svg" alt="" aria-hidden="true" class="pointer-events-none absolute" loading="lazy" />
    <div class="relative mx-auto max-w-[85rem] px-4">
      <div class="card grid p-0 md:flex">
        <div class="relative order-last grid aspect-video h-auto items-center justify-center overflow-hidden md:order-first md:aspect-auto">
          <img
            src="@images/logo/vibeteams-logo.svg"
            alt="VibeTeams Banner Logo"
            class="pointer-events-none translate-y-8 scale-125 object-contain md:-translate-x-12 md:scale-150"
            loading="lazy"
          />
        </div>

        <div class="order-first space-y-6 place-self-center p-6 text-center md:order-last md:space-y-8 md:text-start">
          <h2 class="font-exo-bold text-5xl text-pretty uppercase lg:text-6xl">
            let the <span class="bg-linear-to-r from-mauve-500 to-navy-blue-500 bg-clip-text text-transparent">vibe</span> begin
          </h2>
          <p>
            Build your AI squad, chat with them instantly, and watch your digital team collaborate, discover insights, and bring ideas to life — no
            coding required.
          </p>
          <div>
            <div class="relative grid flex-wrap items-center gap-3 md:flex">
              <UiButton variant="gradient" size="lg" as-child class="flex items-center justify-center gap-2 text-nowrap uppercase">
                <InertiaLink :href="route('login')">
                  Start building Your Team <img src="@images/landing-page/sparkle.svg" alt="Sparkle Asset" />
                </InertiaLink>
              </UiButton>
              <UiButton
                v-if="!$page.props.auth.user"
                variant="secondaryOutline"
                size="lg"
                as-child
                class="px-10 text-nowrap uppercase hover:text-mauve-500 md:w-fit"
              >
                <a :href="route('register')"> sign up </a>
              </UiButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { Button as UiButton } from '@/components/ui/button';

export default {
  name: 'VibeBegin',
  components: {
    UiButton,
  },
};
</script>
